import React from 'react';
import Title from '../../../atoms/Title';
import Logo from '../../../assets/icons/Logo';
import { IHeaderProps } from '../Header';
import HeaderLogoContainer from './HeaderLogoContainer';
import ReactHtmlParser from 'react-html-parser';

interface IHeaderLogoProps {
	centeredLogo: IHeaderProps['centeredLogo'];
	customMessage: IHeaderProps['customMessage'];
	navBarLinks: IHeaderProps['navBarLinks'];
	textLogo: IHeaderProps['textLogo'];
	theme: IHeaderProps['theme'];
	tag: IHeaderProps['tag'];
	tagStyledAs: IHeaderProps['tagStyledAs'];
	logoURL: IHeaderProps['logoURL'];
	logo: IHeaderProps['logo'];
	logoAlt: IHeaderProps['logoAlt'];
	shouldRender: boolean;
};

export default function HeaderLogo(props: Readonly<IHeaderLogoProps>) {
	if (!props.shouldRender) return null;

	if (props.textLogo) {
		return (
			<HeaderLogoContainer
				centeredLogo={props.centeredLogo}
				navBarLinks={props.navBarLinks}
				customMessage={props.customMessage}
			>
				<a
					className={`text-2xl leading-6 no-underline mb-0 Header__text${props.theme !== 'light' ? '' : '--light'}`}
					href={props.textLogo.link}
				>
					<Title className={`text-[2rem] leading-10 mb-0 ${props.theme === 'light' ? 'text-grey-tundora' : 'text-white'}`} tag={props.tag} styledAs={props.tagStyledAs}>
						{ReactHtmlParser(props.textLogo.title)}
					</Title>
				</a>
			</HeaderLogoContainer>
		);
	}

	let logoVariant: 'transparent' | 'light' | 'no-bank' | 'black' | undefined;
	switch (props.theme) {
		case 'dark':
		case 'transparent':
			logoVariant = 'transparent';
			break;
		case 'black-white':
			logoVariant = 'black';
			break;
		case 'no-bank':
			logoVariant = 'no-bank';
			break;
		default:
			logoVariant = undefined;
	}
	const tailwindImg = props.theme === 'black-white' || props.theme === 'light' ? 'max-w-none' : '';
	const tailwindAnchor = props.theme === 'black-white' || props.theme === 'light' ? 'max-h-none' : '';

	return (
		<HeaderLogoContainer
			centeredLogo={props.centeredLogo}
			navBarLinks={props.navBarLinks}
			customMessage={props.customMessage}
		>
			<a className={`${tailwindAnchor} Header__anchor inline-flex max-h-[3.5625rem]`} href={props.logoURL}>
				{!props.logo ? (
					<Logo
						logoAlt={props.logoAlt}
						aria-label='Credit One Bank Home page'
						className={`${tailwindImg} Header__img min-w-[10.25rem] w-full`}
						variant={logoVariant}
					/>
				) : (
					<img
						className='max-h-[3.5625rem]'
						src={props.logo}
						alt={props.logoAlt}
					/>
				)}
			</a>
		</HeaderLogoContainer>
	);
}
